import { useState } from "react";
import { Modal } from "react-bootstrap";

const DeleteConfirmModal = (props) => {
    const [confirmInput, setConfirmInput] = useState('');
    const [alertMgs, setAlertMgs] = useState('');

    const confirmDelete = () => {
        if (props.confirmByInput) {
            if (!confirmInput) {
                alert('Please enter a valid input');
            }
            else if (props.confirmValue?.trim()?.toLowerCase() != confirmInput?.trim()?.toLowerCase()) {
                setAlertMgs('Input value is incorrect !');
            }
            else if (props.confirmValue?.trim()?.toLowerCase() == confirmInput?.trim()?.toLowerCase()) {
                props.onConfirmDelete(true);
                props.setShowDeleteConfirmModal(false);
            }
        }
        else {
            props.onConfirmDelete(true);
            props.setShowDeleteConfirmModal(false);
        }
    }

    const cancelDelete = () => {
        props.setShowDeleteConfirmModal(false)
        props.onCancel();
    }

    return (
        <Modal
            show={() => props.setShowDeleteConfirmModal(true)}
            onHide={cancelDelete}
            backdrop="static"
            keyboard={false}
            size='md'
            dialogClassName="delete-confirm-modal-dialog"
            className="delete-confirm-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label className="form-label" htmlFor="delete-label" dangerouslySetInnerHTML={{__html: props.inputLabel ?? 'Confirm Delete'}}></label>
                    {
                        props.confirmByInput &&
                        <input type="text" className="form-control" value={confirmInput} onInput={e => setConfirmInput(e.target.value)}/>
                    }
                    
                    <div className="confirm-delete-alert-mgs"><span>{ !!alertMgs && alertMgs }</span></div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="btn-area">
                    <a onClick={cancelDelete} className="btn btn-text">Cancel</a>
                    <button type="button" className="btn btn-primary" aria-label="Submit" onClick={confirmDelete} disabled={props.confirmByInput && !confirmInput}>
                        Delete
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteConfirmModal;